module.exports = __webpack_public_path__ + "img/perfection@2x.6f45616.webp";